import { css } from '@emotion/react';
import React from 'react';
import t from 'react-translate';

import { useSelector } from 'react-redux';
import { getNovoAIProperties } from 'redux/selectors/lecture-page';
import { BackdropType } from 'shared/components/nv-modal';

import GenerateButton from '../shared/generate-button';
import AiModal from '../shared/ai-modal';
import AIGeneratedPrompts from './ai-generated-prompts';

/**
 * `Generate Now` button to handle the Course-wide discussion prompts:
 * 1. Opens a Discussion Prompts modal to choose the prompts.
 * 2. Opens the Add course-wide discussion modal with predefined data.
 * @returns Button to handle the GenAI flow of a Discussion component
 */
const GenerateDiscussionPrompts = () => {
  const novoAIProperties = useSelector(getNovoAIProperties);
  const [showModal, setShowModal] = React.useState(false);
  const [hideModal, setHideModal] = React.useState(false);

  const modalStyles = css`
    opacity: ${!hideModal ? 1 : 0};
    transition: opacity .15s ease-in-out;
  `;

  const resetModal = () => {
    setHideModal(false);
    setShowModal(false);
  };

  React.useEffect(() => () => {
    if (showModal) resetModal();
  }, []);

  const handleCloseModal = () => {
    if (showModal) resetModal();
  };

  // The Conditional Modal is a nested modal that follows the Conditional Workflow architecture (see AIGeneratedPrompts). We cannot close this modal and expect the nested modal to remain open. To solve this scenario, we must hide this modal and handle the closing action through a callback.
  const handleHideModal = () => setHideModal(true);

  return (
    <>
      <GenerateButton
        onClick={() => setShowModal(true)}
        text={novoAIProperties.lectureComponentToReplace ? t.LECTURE_PAGES.LHS.NOVO_AI.REGENERATE() : undefined}
      />
      <AiModal
        show={showModal}
        onClose={handleCloseModal}
        body={(
          <AIGeneratedPrompts
            handleCloseModal={handleCloseModal}
            handleHideModal={handleHideModal}
          />
        )}
        modalStyles={modalStyles}
        backdropType={hideModal ? BackdropType.LIGHT : BackdropType.DEFAULT}
      />
    </>
  );
};

export default GenerateDiscussionPrompts;
